import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = () =>
  createStyles({
    outlined: {
      fontSize: '13px',
      transform: 'translate(10px, 9px) scale(1)',
      '&.shrink': {
        transform: 'translate(11px, -5px) scale(.75)',
      },
    },
    notchedOutline: {
      // This class is used by mui to calculate the notch in the outline off of .75x the font size of the input
      // we need to pass it the input font size for the calculation, not the post calculated size
      fontSize: '13px',
      padding: '4px 4px',
    },
    input: {
      fontSize: '13px',
      padding: '8px 12px',
    },
  });

type InputProps = {
  autoFocus?: boolean;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  textBoxWidth?: string;
  disabled?: boolean;
  placeholder?: string;
  startAdornment?: React.ReactNode;
  fullWidth?: boolean;
};

type Props = InputProps & WithStyles<typeof styles>;

export const UiFilterTextField = withStyles(styles)(
  ({
    autoFocus,
    classes,
    className,
    label,
    value,
    onChange,
    textBoxWidth,
    disabled,
    placeholder,
    startAdornment,
    fullWidth,
  }: Props) => {
    const handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      onChange(target.value);
    };

    const handleClearClick = () => {
      onChange('');
    };

    const adornedStartClasses = {
      adornedStart: 'u-padding-x-sm',
      inputAdornedStart: 'u-no-padding-left',
    };

    return (
      <div
        className={`u-display-flex u-flexDirection-column u-alignItems-flexStart ${
          className ?? ''
        }`}
      >
        <TextField
          className={textBoxWidth}
          variant="outlined"
          placeholder={placeholder || `Filter by ${label}`}
          label={label}
          value={value}
          onChange={handleChange}
          autoFocus={autoFocus}
          InputProps={{
            classes: {
              input: classes.input,
              notchedOutline: classes.notchedOutline,
              ...(startAdornment ? adornedStartClasses : {}),
            },
            startAdornment,
          }}
          InputLabelProps={{ classes: { outlined: classes.outlined, shrink: 'shrink' } }}
          disabled={disabled}
          fullWidth={fullWidth}
        />
        {value && (
          <div
            role="presentation"
            className="typo-subtitle typo-link u-margin-top-xs u-display-inlineBlock"
            onClick={handleClearClick}
          >
            CLEAR
          </div>
        )}
      </div>
    );
  },
);
